export interface AIPhoneEntryIntent {
    callId: string | null;
    consumeEntryParams: boolean;
}

export function buildAIPhonePath(callId?: string | null): string {
    const normalizedCallId = callId?.trim();
    if (!normalizedCallId) {
        return "/app/ai-phone";
    }

    const params = new URLSearchParams({ callId: normalizedCallId });
    return `/app/ai-phone?${params.toString()}`;
}

export function getAIPhoneEntryIntent(searchParams: URLSearchParams): AIPhoneEntryIntent {
    const normalizedCallId = searchParams.get("callId")?.trim() || null;
    const legacyAction = searchParams.get("action")?.trim();

    return {
        callId: normalizedCallId,
        consumeEntryParams: normalizedCallId !== null || legacyAction === "call",
    };
}